import {
  Box,
  Container,
  Divider,
  Grid,
  Heading,
  Icon,
  Image,
  Link,
  Text,
} from "@chakra-ui/react";
import img_bg from "../img/img-bg.png";
import PerspectiveImg from "../img/mob.png";
import React from "react";
import PerspectiveBox from "../components/PerspectiveBox";
import { RightLongArrow } from "../components/Icons";
import BlogImgOne from "../img/understanding.png";
import BlogImgTwo from "../img/mob.png";
import BlogImgThree from "../img/healthcare.png";
import BlogImgFour from "../img/Benefits.png";
import {Helmet} from "react-helmet";
import {absoluteUrl} from "../components/Utils";

const Perspective = () => {
  const BlogData = [
    {
      id: 0,
      img: BlogImgOne,
      title: "Understanding the Leasing Process: What to expect when leasing a medical office space for your practice",
      link: "/understanding-the-leasing-process",
    },
    {
      id: 1,
      img: BlogImgTwo,
      title: "What is an MOB (Medical Office Building) and Why It Matters in Healthcare",
      link: "/what-is-mob",
    },
    {
      id: 2,
      img: BlogImgThree,
      title: "Healthcare Real Estate Leasing Terms Simplified",
      link: "/healthcare-real-estate-terms-simplified",
    },
    {
      id: 3,
      img: BlogImgFour,
      title: "Benefits of Leasing vs. Owning Medical Office Buildings",
      link: "/benefits-of-leasing",
    },
  ];
  return (
      <>
        <Helmet>
          <title>Welltower Medical Office For Lease - Our Perspective</title>
          <link rel="canonical" href={ absoluteUrl( "/perspective")} />
        </Helmet>
    <Box pt={"78px"} bgGradient="radial-gradient(36.09% 69.11% at 100% 33.15%, rgba(112, 207, 236, 0.48) 0%, rgba(116, 214, 241, 0) 100%)">
      <Container maxW={{ lg: "40%", md: "60%" }}>
        <Box textAlign={"center"} mt={12}>
          <Text fontSize={"2xl"} color={"Teal"}>
            Our Perspective
          </Text>
          <Heading
            mb={12}
            fontSize={{ xl: "5xl", base: "3xl" }}
            color={"DarkTeal"}
          >
            Leading the Way
          </Heading>
          <Text color={"DarkBlue"} pb={24}>
            It’s our job to monitor trends and track changes that impact our
            industry. We want to share our insights, so you can make the best
            decisions possible for your business.
          </Text>
        </Box>
      </Container>
      <Box
        pos={"relative"}
        w={{ md: "95%", base: "100%" }}
        marginRIght={"auto"}
      >
        <Container
          maxW={{ lg: "90%", base: "100%" }}
          mt={{ lg: 28, md: 16, base: 8 }}
        >
          <Box
            bgImage={{ lg: img_bg, base: "" }}
            h={{ lg: "480px", base: "100%" }}
            bgSize={"cover"}
            bgRepeat={"no-repeat"}
          >
            <Box
              w={{ lg: "50%", sm: "80%", base: "100%" }}
              pt={{ lg: 48, base: 0 }}
              ps={{ lg: 8, base: 0 }}
            >
              <Image
                display={{ lg: "none", base: "block" }}
                src={PerspectiveImg}
                top={-24}
                right={0}
                borderTopRightRadius={"300px"}
                h={"336px"}
                objectFit={"cover"}
                objectPosition={"center center"}
              />
              <Heading color={"Teal"} my={6}>
                What is an MOB (Medical Office Building) and Why It Matters in
                Healthcare
              </Heading>
              {/* <Text color={{ lg: "white", base: "black" }}>
                Securing the ideal medical office building for your practice can
                be a complex endeavor.
              </Text> */}
              <Link
                href="/what-is-mob"
                display={"flex"}
                alignItems={"center"}
                color={"Teal"}
                justifyContent={"start"}
                mt={10}
                gap={2}
              >
                Read Article
                <Icon
                  as={RightLongArrow}
                  w={"30%"}
                  sx={{
                    path: {
                      fill: "Teal",
                    },
                  }}
                />
              </Link>
            </Box>
            <Image
              display={{ lg: "block", base: "none" }}
              src={PerspectiveImg}
              position={"absolute"}
              w={"50%"}
              h={"500px"}
              objectFit={"cover"}
              borderRadius={" 0px 300px 0px 0px"}
              top={-24}
              right={0}
            />
          </Box>
        </Container>
      </Box>
      <Container maxW={{ md: "90%", base: "100%" }} px={{ md: 4, base: 0 }}>
        <Divider borderColor={"DarkTeal"} my={{ md: 28, base: 12 }} />
        <Grid
          mt={12}
          gridTemplateColumns={{ md: "repeat(2, 1fr)", sm: "repeat(1, 1fr)" }}
          gap={{ md: 12, base: 0 }}
          alignItems={"center"}
          sx={{
            ".chakra-text": {
              color: "DarkBlue",
            },
            line: {
              stroke: "DarkBlue !important",
            },
            ".PerspectiveBox": {
              _first: {
                borderTop: "1px solid #CED2D6 ",
              },
              borderBottom: "1px solid #CED2D6 ",
              background: "#FFF  ",
            },
          }}
        >
          {BlogData?.map((item) => {
            return (
              <PerspectiveBox
                key={item?.id}
                link={item?.link}
                title={item?.title}
                blogImg={item?.img}
              />
            );
          })}
        </Grid>
      </Container>
    </Box>
      </>
  );
};

export default Perspective;
